import React from "react";
import {
  Container,
  Box,
  Typography,
  useTheme,
  Chip,
  Stack,
  Divider,
  Paper,
} from "@mui/material";
import { AccessTime, DateRange } from "@mui/icons-material";
import { useParams, useNavigate } from "react-router-dom";

export default function ArticleDetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  const theme = useTheme();

  // نمونه دیتا برای مقاله فعلی (در حالت واقعی از API میاد)
  const article = {
    id: 1,
    title: "۱۰ نکته طلایی برای افزایش عضله‌سازی",
    description:
      "با رعایت این نکات ساده می‌توانید روند عضله‌سازی خود را تا ۲ برابر افزایش دهید.",
    content: `
      <p>عضله‌سازی یکی از اهداف اصلی بسیاری از ورزشکاران و علاقه‌مندان به تناسب اندام است. اما بسیاری از افراد با وجود تمرینات منظم، به نتیجه مطلوب نمی‌رسند. در این مقاله به ۱۰ نکته کلیدی می‌پردازیم که می‌تواند مسیر عضله‌سازی شما را متحول کند.</p>
      
      <h2>۱. پروتئین کافی مصرف کنید</h2>
      <p>پروتئین بلوک سازنده عضلات است. برای عضله‌سازی مؤثر، روزانه به ازای هر کیلوگرم وزن بدن، ۱.۶ تا ۲.۲ گرم پروتئین نیاز دارید. منابع خوب پروتئین شامل مرغ، ماهی، تخم‌مرغ، لبنیات، حبوبات و مکمل‌هایی مثل وی پروتئین هستند.</p>
      
      <h2>۲. تمرینات سنگین و پیشرونده انجام دهید</h2>
      <p>برای رشد عضلات، باید آن‌ها را به چالش بکشید. اصل اضافه بار پیشرونده یعنی به مرور زمان وزنه‌ها را افزایش دهید یا تعداد تکرارها و ست‌ها را بیشتر کنید. این کار باعث می‌شود عضلات مجبور به تطابق و رشد شوند.</p>
      
      <h2>۳. استراحت و ریکاوری را جدی بگیرید</h2>
      <p>عضلات در زمان استراحت رشد می‌کنند، نه در زمان تمرین. هر عضله به ۴۸ ساعت استراحت بین جلسات تمرینی نیاز دارد. خواب کافی (۷-۹ ساعت در شب) نیز برای ترشح هورمون رشد ضروری است.</p>
      
      <h2>۴. کالری مازاد مصرف کنید</h2>
      <p>برای عضله‌سازی، بدنتان به انرژی اضافی نیاز دارد. حدود ۳۰۰-۵۰۰ کالری بالاتر از نیاز روزانه مصرف کنید. این کالری باید از منابع سالم مثل کربوهیدرات‌های پیچیده، چربی‌های مفید و پروتئین تأمین شود.</p>
      
      <h2>۵. حرکات مرکب را اولویت دهید</h2>
      <p>حرکاتی مثل اسکوات، ددلیفت، پرس سینه و بارفیکس چندین گروه عضلانی را همزمان درگیر می‌کنند. این حرکات بیشترین تأثیر را در رشد کلی عضلات دارند و باید هسته اصلی برنامه تمرینی شما باشند.</p>
      
      <h2>۶. هیدراته بمانید</h2>
      <p>کم‌آبی بدن می‌تواند عملکرد تمرینی شما را تا ۳۰٪ کاهش دهد. روزانه حداقل ۳-۴ لیتر آب بنوشید. در حین تمرینات سنگین، این مقدار باید بیشتر شود.</p>
      
      <h2>۷. ثبات و تداوم داشته باشید</h2>
      <p>عضله‌سازی یک فرآیند تدریجی است و نتایج فوری ندارد. حداقل ۳-۴ بار در هفته به مدت ۶-۸ هفته تمرین کنید تا تغییرات قابل توجهی مشاهده کنید. صبور باشید و به مسیر ادامه دهید.</p>
      
      <h2>۸. فرم صحیح تمرینات را رعایت کنید</h2>
      <p>استفاده از وزنه سنگین با فرم اشتباه نه تنها کمکی به رشد عضلات نمی‌کند، بلکه خطر آسیب را افزایش می‌دهد. روی یادگیری تکنیک صحیح تمرکز کنید، سپس وزنه را افزایش دهید.</p>
      
      <h2>۹. مکمل‌های مؤثر را بشناسید</h2>
      <p>کراتین، وی پروتئین و بتا آلانین از جمله مکمل‌هایی هستند که اثربخشی علمی دارند. اما به یاد داشته باشید که مکمل‌ها فقط مکمل هستند و جایگزین تغذیه و تمرین مناسب نمی‌شوند.</p>
      
      <h2>۱۰. پیشرفت خود را ثبت کنید</h2>
      <p>دفترچه تمرینی داشته باشید و وزنه‌ها، تکرارها و احساس خود را هر جلسه ثبت کنید. این کار به شما انگیزه می‌دهد و الگوهای پیشرفت را نشان می‌دهد.</p>
      
      <p>با رعایت این ۱۰ نکته و داشتن انضباط، می‌توانید به نتایج شگفت‌انگیزی در عضله‌سازی دست پیدا کنید. به یاد داشته باشید که هر بدن متفاوت است، بنابراین برنامه را با نیازهای خود تنظیم کنید.</p>
    `,
    image: "/media/sample/sample.jpg",
    category: "بدنسازی",
    author: "مهدی کریمی",
    authorAvatar: "https://randomuser.me/api/portraits/men/1.jpg",
    authorBio:
      "مربی حرفه‌ای بدنسازی با بیش از ۱۰ سال سابقه تدریس و مربیگری در باشگاه‌های معتبر تهران",
    readTime: 5,
    date: "۱۴۰۳/۰۲/۱۵",
    views: 1247,
    comments: 23,
  };

  return (
    <Box
      sx={{
        bgcolor: "background.default",
        minHeight: "100svh",
        py: 4,
        pt: { xs: 10, xl: 4 },
      }}
    >
      <Container maxWidth="xl" sx={{ px: { xs: 2, md: 3 } }}>
        {/* هدر مقاله */}
        <Box sx={{ mb: 4 }}>
          {/* دسته‌بندی */}
          <Chip
            label={article.category}
            sx={{
              bgcolor: `${theme.palette.primary.main}15`,
              color: theme.palette.primary.main,
              fontWeight: 600,
              fontSize: "0.75rem",
              mb: 2,
            }}
          />

          {/* عنوان */}
          <Typography
            variant="h1"
            sx={{
              fontWeight: 800,
              mb: 2,
              lineHeight: 1.3,
              fontSize: { xs: "1.4rem", md: "1.7rem" },
            }}
          >
            {article.title}
          </Typography>

          {/* توضیح کوتاه */}
          <Typography
            variant="h6"
            sx={{
              color: "text.secondary",
              fontWeight: 400,
              mb: 3,
              fontSize: { xs: ".9rem", md: "1rem" },
            }}
          >
            {article.description}
          </Typography>

          {/* اطلاعات نویسنده و مقاله */}
          <Stack direction="row" gap={3}>
            <Stack direction="row" alignItems="center" gap={0.5}>
              <DateRange sx={{ fontSize: 18, color: "text.secondary" }} />
              <Typography variant="body2" color="text.secondary">
                {article.date}
              </Typography>
            </Stack>
            <Stack direction="row" alignItems="center" gap={0.5}>
              <AccessTime sx={{ fontSize: 18, color: "text.secondary" }} />
              <Typography variant="body2" color="text.secondary">
                {article.readTime} دقیقه مطالعه
              </Typography>
            </Stack>
          </Stack>
        </Box>

        {/* تصویر اصلی */}
        <Box
          component="img"
          src={article.image}
          alt={article.title}
          sx={{
            width: "100%",
            borderRadius: 4,
            mb: 4,
            objectFit: "cover",
            maxHeight: 500,
          }}
        />

        <Divider sx={{ mb: 4 }} />

        {/* محتوای اصلی مقاله */}
        <Paper
          elevation={0}
          sx={{
            p: { xs: 2, md: 4 },
            borderRadius: 3,
            bgcolor: "background.paper",
            mb: 5,
          }}
        >
          <Box
            dangerouslySetInnerHTML={{ __html: article.content }}
            sx={{
              "& h2": {
                fontSize: "1.1rem",
                fontWeight: 600,
                mt: 3,
                mb: 2,
                color: theme.palette.text.primary,
              },
              "& p": {
                fontSize: ".9rem",
                lineHeight: 1.8,
                mb: 2,
                color: theme.palette.text.secondary,
              },
              "& ul, & ol": {
                mb: 2,
                pr: 2,
              },
              "& li": {
                mb: 1,
                color: theme.palette.text.secondary,
              },
              "& strong": {
                color: theme.palette.primary.main,
              },
              direction: "rtl",
            }}
          />
        </Paper>
      </Container>
    </Box>
  );
}
